import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const FAQsApi = createApi({
  reducerPath: "FAQsApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    customerFaqsList: builder.query({
      query: () => {
        return {
          url: `v1/gc/faqs/all/`, //All FAQs Listing -> Customer
          method: "GET",
        };
      },
    }),

    adminFaqsList: builder.query({
      query: ({ page, page_size }) => ({
        url: `v1/gc/faqs/?page=${page}&page_size=${page_size}`, //All FAQs Listing -> Admin
        method: "GET",
      }),
    }),

    createNewFaqs: builder.mutation({
      query: ({ body }) => ({
        url: `v1/gc/faqs/`, //Create New FAQs
        method: "POST",
        body,
      }),
    }),

    newFaqsAfter: builder.mutation({
      query: ({ body }) => ({
        url: `v1/gc/faqs/`, //Create New FAQs After
        method: "POST",
        body,
      }),
    }),

    bulkImportFaqs: builder.mutation({
      query: ({ body }) => {
        return {
          url: `v1/gc/faqs/bulk_import/`, //Bulk Import FAQs
          method: "POST",
          body,
        };
      },
    }),

    updateFaqById: builder.mutation({
      query: ({ body, id }) => {
        return {
          url: `v1/gc/faqs/${id}/`, //Update FAQs
          method: "PATCH",
          body,
        };
      },
    }),

    deleteFaq: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/gc/faqs/${id}/`, //Delete FAQs
        method: "DELETE",
        body,
      }),
    }),
  }),
});

export const {
    useCustomerFaqsListQuery,
  useAdminFaqsListQuery,
  useCreateNewFaqsMutation,
  useNewFaqsAfterMutation,
  useBulkImportFaqsMutation,
  useUpdateFaqByIdMutation,
  useDeleteFaqMutation,
} = FAQsApi;
